export var IndicatorType;
(function (IndicatorType) {
    IndicatorType["Boolean"] = "boolean";
    IndicatorType["Number"] = "number";
    IndicatorType["Text"] = "text";
})(IndicatorType || (IndicatorType = {}));
//# sourceMappingURL=indicator-type.js.map